import { Chip } from "@mui/material";
import React from "react";
import { CustomButton, CustomIconButton, icon } from "../../../../../../common/components";
import styles from "./FlagRow.module.css";

export default function FlagRow({ feat, onSelectRow }) {
	const { description, id, name, packages, projects } = feat;
	const packageList = packages ? packages.split(",").filter(Boolean) : [];

	return (
		<div key={id} className={styles.row}>
			<div>
				<span>{name}</span>
			</div>
			<div>
				<span>{description}</span>
				<CustomIconButton
					btnClassName={styles.import__btn}
					icon={icon.faPen}
					iconColor="var(--grey-400)"
					size="md"
					onClick={() => {
						onSelectRow(feat, "information");
					}}
				/>
			</div>
			<div
				className={styles.packagesCell}
				role="button"
				tabIndex={0}
				onClick={() => onSelectRow(feat, "packages")}
				onKeyDown={(e) => e.key === "Enter" && onSelectRow(feat, "packages")}
			>
				{packageList.length > 0 ? (
					packageList.map((pkg) => <Chip key={pkg} label={pkg} size="small" />)
				) : (
					<span>—</span>
				)}
			</div>
			<div>
				<CustomButton
					variant="outlined"
					onClick={() => {
						onSelectRow(feat, "projects");
					}}
				>
					{projects}
				</CustomButton>
			</div>
			<div />
		</div>
	);
}
